<template>
  <div style="padding-bottom: 50px">
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
          <!-- <el-select
            style="margin-left: 10px"
            v-model="typeValue"
            placeholder="请选择食材类型"
            @visible-change="GetHe_FoodTypeList"
          >
            <el-option
              v-for="item in typeList"
              :key="item.Id"
              :label="item.value"
              :value="item.Id"
            >
            </el-option>
          </el-select> -->
          <el-button type="goon" style="margin-left: 10px" @click="onSearch"
            >查询</el-button
          >
          <el-button type="goon" @click="onClickOpen">导出</el-button>
          <el-button type="goon" @click="onOpenReport">报告</el-button>
          <el-button type="goon" @click="onEmpty">清空</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-box">
        <div
          class="tui-box-item"
          v-for="(item, index) in tabbar"
          :key="index"
          @click="onClickCurrent(index)"
          :class="currentIndex == index ? 'tui-box-active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
    </el-card>
    <!-- <template v-if="currentIndex == 0">
      <first-report :tableData="tableData"></first-report>
    </template> -->
    <template v-if="currentIndex == 0">
      <two-report
        :nutritionList="nutritionList"
        :traceElement="traceElement"
      ></two-report>
    </template>
    <template v-if="currentIndex == 1">
      <three-report
        :independent="independent"
        :threeIndependent="threeIndependent"
        :animal="animal"
        :UpdateString="UpdateString"
      ></three-report>
    </template>
  </div>
</template>
<script>
import firstReport from "../../../components/Report/first.vue";
import twoReport from "../../../components/Report/Twos.vue";
import threeReport from "../../../components/Report/Three.vue";
import {
  getWeekStartDate,
  getWeekEndDate,
} from "../../../../util/otherRenders";
import {
  GetHe_FoodTypeList,
  GetEveryDayEveryOneFood,
  GetNutrientSource,
  GetFoodEvaluate,
} from "../../../api/api";

export default {
  components: {
    firstReport,
    twoReport,
    threeReport,
  },
  data() {
    return {
      options: [],
      value: "",
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      tabbar: [
        {
          name: "营养分布来源",
        },
        {
          name: "记账法膳食营养评价",
        },
      ],
      currentIndex: 1,
      starttime: [],
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth()
            );
          } else {
            return false;
          }
        },
      },
      selectData: "",
      typeList: [],
      typeValue: null,
      userInfo: {},
      nutritionList: {},
      traceElement: [],
      independent: [],
      threeIndependent: [],
      animal: [],
      UpdateString: "",
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();

    switch (this.$route.name) {
      case "营养分布来源":
        this.currentIndex = 0;
        this.GetNutrientSource();
        break;
      case "记账法膳食营养评价":
        this.currentIndex = 1;
        this.GetFoodEvaluate();
        break;
    }
  },
  methods: {
    // 导出
    async onClickOpen() {
      switch (this.currentIndex) {
        // case 0:
        //   window.open(
        //     `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetPeopleDayPeport?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        //     "_brank"
        //   );
        //   break;
        case 0:
          window.open(
            `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetNutrientSource?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
            "_brank"
          );
          break;
        case 1:
          window.open(
            `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetFoodEvaluate?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
            "_brank"
          );
          break;
      }
    },
    async onEmpty() {
      this.typeValue = null;
      switch (this.$route.name) {
        // case "人均日食材消耗量":
        //   this.currentIndex = 0;
        //   await this.GetEveryDayEveryOneFood();
        //   break;
        case "营养分布来源":
          this.currentIndex = 0;
          this.GetNutrientSource();
          break;
        case "记账法膳食营养评价":
          this.currentIndex = 1;
          this.GetFoodEvaluate();
          break;
      }
    },
    // 进入报告
    onOpenReport() {
      this.$router.push({
        path: "/Report",
        query: {
          StartDate: this.starttime[0],
          EndDate: this.starttime[1],
        },
      });
    },
    // 分账
    async GetFoodEvaluate() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetFoodEvaluate(params);
      if (res.data.success) {
        this.independent = [
          {
            name: "蛋白质",
            day_food: res.data.response.HeatAndProtein.AverageProtein,
            everyDayProtein: res.data.response.HeatAndProtein.EveryDayProtein,
          },
          {
            name: "热量",
            day_food: res.data.response.HeatAndProtein.AverageHeat,
            everyDayProtein: res.data.response.HeatAndProtein.EveryDayHeat,
          },
        ];
        this.threeIndependent = res.data.response.ProteinFatCarbohydrate;

        this.animal = res.data.response.AnimalAndBeans;
        this.UpdateString = res.data.response.UpdateString;
      } else {
      }
    },
    // 营养分布
    async GetNutrientSource() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetNutrientSource(params);
      if (res.data.success) {
        this.traceElement = [
          {
            name: "钙(mg/d)",
            h1z3: "600",
            h4z6: "800",
            average: "600.00",
            highest: "1500.00",
            calcium: res.data.response.TraceElement.Calcium,
            recommendCalcium: res.data.response.TraceElement.RecommendCalcium,
          },
          {
            name: "锌(mg/d)",
            h1z3: "4",
            h4z6: "5.5",
            average: "4.00",
            highest: "12",
            calcium: res.data.response.TraceElement.Zinc,
            recommendCalcium: res.data.response.TraceElement.RecommendZinc,
          },
          {
            name: "铁(mg/d)",
            h1z3: "9",
            h4z6: "10",
            average: "9.00",
            highest: "25.00",
            calcium: res.data.response.TraceElement.Iron,
            recommendCalcium: res.data.response.TraceElement.RecommendIron,
          },
          {
            name: "维生素A(μg)(视黄醇)",
            h1z3: "310",
            h4z6: "360",
            average: "310.00",
            highest: "900",
            calcium: res.data.response.TraceElement.VitaminA,
            recommendCalcium: res.data.response.TraceElement.RecommendVitaminA,
          },
          {
            name: "维生素B1(mg/d)",
            h1z3: "0.6",
            h4z6: "0.8",
            average: "0.60",
            highest: "--",
            calcium: res.data.response.TraceElement.VitaminB1,
            recommendCalcium: res.data.response.TraceElement.RecommendVitaminB1,
          },
          {
            name: "维生素B2(mg/d)",
            h1z3: "0.6",
            h4z6: "0.7",
            average: "0.60",
            highest: "--",
            calcium: res.data.response.TraceElement.VitaminB2,
            recommendCalcium: res.data.response.TraceElement.RecommendVitaminB2,
          },
          {
            name: "维生素C(mg/d)",
            h1z3: "40",
            h4z6: "50",
            average: "40.00",
            highest: "400",
            calcium: res.data.response.TraceElement.VitaminC,
            recommendCalcium: res.data.response.TraceElement.RecommendVitaminC,
          },
          {
            name: "维生素E(mg/d)",
            h1z3: "",
            h4z6: "1.05",
            average: "",
            highest: "",
            calcium: res.data.response.TraceElement.VitaminE,
            recommendCalcium: res.data.response.TraceElement.RecommendVitaminE,
          },
        ];
        this.nutritionList = res.data.response;
      } else {
        this.nutritionList = {};
      }
    },
    onSearch() {
      if (this.currentIndex == 0) {
        this.GetNutrientSource();
      } else if (this.currentIndex == 1) {
        this.GetFoodEvaluate();
      }
    },
    async GetEveryDayEveryOneFood() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetEveryDayEveryOneFood(params);
      if (res.data.success) {
        this.tableData = res.data.response;
      } else {
        this.tableData = [];
      }
    },
    async GetHe_FoodTypeList() {
      let res = await GetHe_FoodTypeList();
      if (res.data.success) {
        this.typeList = res.data.response;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async getNowTime() {
      this.starttime.push(getWeekStartDate());
      this.starttime.push(getWeekEndDate());
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    onClickCurrent(index) {
      this.currentIndex = index;
      if (this.currentIndex == 0) {
        this.GetNutrientSource();
      } else if (this.currentIndex == 1) {
        this.GetFoodEvaluate();
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-box {
  width: 3.125rem;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}
.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>